import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#EFC768" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/Kiyo-Sushi-499485853879633/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Ten Victoria Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/sushitenoakbay/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sushi Ten Victoria Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#EFC768" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/Kiyo-Sushi-499485853879633/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Ten Victoria Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/sushitenoakbay/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sushi Ten Victoria Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
